export default "__VITE_ASSET___zc9bz12__"